export type ID = undefined | null | number | string

function isNotEmpty(obj: unknown) {
    return obj !== undefined && obj !== null && obj !== ''
}

export {
    isNotEmpty,
}
